import React from "react";
import {
  UserIcon, StorefrontIcon, GlobeSimpleIcon, PhoneIcon, AirplaneTakeoffIcon,
  HouseSimpleIcon, ShieldCheckIcon,
} from "@phosphor-icons/react";

/**
 * Compact channel icon for reservation bars, tables and room cards.
 * Each channel has a distinct colour so front desk can spot at a glance
 * which OTA drove a booking.
 */
export const CHANNEL_META = {
  direct: { label: "Direct", short: "D", color: "#2F5D50" },       // pine
  walk_in: { label: "Walk-in", short: "W", color: "#7A6A4F" },
  phone: { label: "Phone", short: "P", color: "#8A6D3B" },
  booking_com: { label: "Booking.com", short: "B", color: "#003580" },
  mmt: { label: "MakeMyTrip", short: "MMT", color: "#EB2226" },
  yatra: { label: "Yatra", short: "Y", color: "#F58220" },
  agoda: { label: "Agoda", short: "A", color: "#5D3E9C" },
  expedia: { label: "Expedia", short: "E", color: "#FFC500" },
  airbnb: { label: "Airbnb", short: "Ab", color: "#FF5A5F" },
  goibibo: { label: "Goibibo", short: "G", color: "#F58220" },
  public_widget: { label: "Booking widget", short: "QR", color: "#2F5D50" },
  other: { label: "Other", short: "?", color: "#666" },
};

/** Round chip showing the channel — 18px by default. */
export function ChannelChip({ channel = "direct", size = 18, showLabel = false }) {
  const meta = CHANNEL_META[channel] || CHANNEL_META.other;
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full font-bold text-[9px] text-white shrink-0"
      style={{
        background: meta.color,
        width: showLabel ? "auto" : size,
        height: size,
        padding: showLabel ? "0 8px 0 4px" : 0,
        justifyContent: "center",
        letterSpacing: "0.02em",
      }}
      title={meta.label}
      data-testid={`channel-chip-${channel}`}
    >
      <span
        className="rounded-full flex items-center justify-center"
        style={{ width: size, height: size, background: "rgba(255,255,255,0.16)" }}
      >
        {meta.short}
      </span>
      {showLabel && <span className="ml-1 whitespace-nowrap">{meta.label}</span>}
    </span>
  );
}

export const ALL_CHANNELS = Object.keys(CHANNEL_META);
